import React, { useState } from 'react';
import { useFormik } from 'formik';

import UIForm from '../../../ui/Form';
import Input from '../../../ui/Form/Input';
import Box from '../../../ui/Box';
import Text from '../../../ui/Text';
import Link from '../../../ui/Link';
import Spinner from '../../../ui/Spinner';
import { AccentButton } from '../../../ui/Button';

import * as Styles from './FormStyles';

export interface StateInterface {
  from: {
    pathname: string;
  };
}

interface Props {
  readonly error: boolean;
  readonly loading: boolean;
  onSubmit(data: FormValues): any;
}

export type FormValues = {
  username: string;
  password: string;
};

const validate = (values: FormValues): Partial<FormValues> => {
  const errors: Partial<FormValues> = {};

  if (!values.username) {
    errors.username = 'O e-mail é obrigatório';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.username)) {
    errors.username = 'E-mail inválido';
  }

  if (!values.password) {
    errors.password = 'A senha é obrigatório';
  }

  return errors;
};

const Form: React.FC<Props> = ({ error, loading, onSubmit }: Props) => {
  const [passwordShow, setPasswordShow] = useState(false);

  const showError = (inputName: keyof FormValues): boolean =>
    Boolean(form.errors[inputName] && form.touched[inputName]);

  const form = useFormik<FormValues>({
    initialValues: {
      username: '',
      password: '',
    },
    validate,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      onSubmit(values);
    },
  });

  const togglePasswordVisiblity = (): void => {
    setPasswordShow(!passwordShow);
  };

  return (
    <Styles.Container>
      <Styles.TitleContainer>
        <Styles.Logo />
        <Text align="center" color="black">
          Simples, seguro e <Styles.Highlight>100% Gratuito</Styles.Highlight>
        </Text>
      </Styles.TitleContainer>

      <UIForm onSubmit={form.handleSubmit}>
        {error && <Box type="error" marginBottom={16}>E-mail e/ou senha inválidos.</Box>}
        <Input
          onInputChange={form.handleChange}
          errors={showError('username') ? form.errors.username : undefined}
          name="username"
          label="E-mail"
          placeholder="Digite seu e-mail de cadastro"
          type="text"
          required
        />
        <Input
          onInputChange={form.handleChange}
          errors={showError('password') ? form.errors.password : undefined}
          name="password"
          label="Senha"
          placeholder="Digite sua senha"
          type={passwordShow ? 'text' : 'password'}
          passwordHandlers={{
            passwordShow,
            handlePasswordVisibility: () => togglePasswordVisiblity(),
          }}
          required
        />
        <Text align="right" color="black">
          <Link to="/forgot-password" color="black" decoration>
            <Styles.Highlight> Esqueceu sua senha?</Styles.Highlight>
          </Link>
        </Text>
        <AccentButton bgColor="primary" type="submit" disabled={loading}>
          {loading ? <Spinner size="18px" /> : 'Acessar'}
        </AccentButton>
        <Text align="center" color="black">
          Não tem Acesso? <Link to="/register">Cadastre-se usando SNGPC</Link>
        </Text>
      </UIForm>
    </Styles.Container>
  );
};

export default Form;
